import React from "react";

import {
    getDataFromResponse,
    getDataWithPromise,
    getNumRowsFromResponse, handleAjaxError,
} from 'root/DataFunctions/BaseDataFns';

export const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    display: 'inline-block',
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const formatGroupLabel = data => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);

export const genericListboxFetch = ({url, keyFieldName, labelFieldName, additionalFields, filterFn }) =>
{
    return new Promise((resolve, reject) =>
    {
        if (url === null || url === '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                let rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                // Perform any custom filtering ( The filterFn must accept an array as parameters and return an array
                if ( filterFn !== undefined )
                {
                    if ( typeof filterFn !== 'function' )
                    {
                        throw new Error ("Invalid filter Function passed to genericListboxFetch") ;
                    }
                    else
                    {
                        rows = filterFn ( rows ) ;
                    }
                }

                // Map the data into the format the listbox wants.
                // Each listbox will map the value and label elements from the returned listbox data
                const rval =  rows.map((entry) =>
                {
                    let arr = {} ;

                    // Add any additional fields to the response
                    if ( additionalFields !== undefined )
                    {
                        let initialValue = {};
                        arr = additionalFields.reduce((obj, item) => {
                            return {
                                ...obj,
                                [item]: entry[item],
                            };
                        }, initialValue);
                    }

                    return { value: +(entry[keyFieldName]), label: entry[labelFieldName], ...arr} ;
                }) ;

                resolve ( rval );
            })
            .catch((jqXHR, textStatus, error) =>
            {
                handleAjaxError(jqXHR, textStatus, error) ;

                reject(jqXHR, textStatus, error);
            });
        }
    });
}
